export const INITIAL_STATE = {
    allPayrollItems: [],
};

export const payrollItemReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'RECEIVE_BUSINESS_RESOURCES': {
            if ('allPayrollItems' in action.payload) {
                const newState = { ...state };
                ['allPayrollItems'].forEach(k => {
                    if (k in action.payload) {
                        newState[k] = action.payload[k];
                    }
                });
                return newState;
            } else {
                return state;
            }
        }
        case 'SET_ALL_PAYROLL_ITEMS':
            return {
                ...state,
                allPayrollItems: action.payload,
            };
        case 'ADD_PAYROLL_ITEM':
            return {
                ...state,
                isSaving: true,
            };
        case 'ADD_PAYROLL_ITEM_SUCCESS':
            return {
                ...state,
                isSaving: false,
            };
        case 'ADD_PAYROLL_ITEM_ERROR':
            return {
                ...state,
                isSaving: false,
            };
        case 'LOGOUT':
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default payrollItemReducer;
